import { FilterType } from '@/models/filter/FilterType';

const FILTER_TYPE_VALUES: ReadonlySet<string> = new Set(Object.values(FilterType));

export const isFilterType = (key: string): key is FilterType => FILTER_TYPE_VALUES.has(key);
